var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.006 14.6602L13.8698 15.7148L11.8119 13.8047V20.25H10.1959V13.8047L8.13809 15.7148L7.00184 14.6602L11.0039 10.9336L15.006 14.6602ZM24.5 17.0273L17.4679 23.5664L14.0718 20.4023L15.208 19.3477L17.4679 21.4336L23.3638 15.9727L24.5 17.0273ZM2.11599 22.5H13.4279V24H0.5V0H14.5768L21.5079 6.43359V15.0352L19.8919 16.5352V7.5H13.4279V1.5H2.11599V22.5ZM15.0439 6H18.743L15.0439 2.56641V6Z",
    fill: "#FF9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8ad8e91e46eaacacac6a2d6d10613311.svg";
export { ForwardRef as ReactComponent };